import { type FragmentOf, graphql } from "@/data-access/graphql";
import {
  BroadcastKeyMessageGroupFragment,
  type BroadcastKeyMessageItemFragment,
  PodcastKeyMessageGroupFragment,
  type PodcastKeyMessageItemFragment,
} from "../fragments/key-message-fragments";

// ============================================================================
// Types — fully inferred from fragments, no manual intersections needed.
// broadcastKeyMessageItems / podcastKeyMessageItems are selected inside the
// group fragments, so FragmentOf already includes them.
// ============================================================================

export type BroadcastKMItem = FragmentOf<
  typeof BroadcastKeyMessageItemFragment
>;
export type BroadcastKMGroup = FragmentOf<
  typeof BroadcastKeyMessageGroupFragment
>;

export type PodcastKMItem = FragmentOf<typeof PodcastKeyMessageItemFragment>;
export type PodcastKMGroup = FragmentOf<typeof PodcastKeyMessageGroupFragment>;

// ============================================================================
// Broadcast Key Message Groups Query
// ============================================================================

export const GetBroadcastKeyMessageGroups = graphql(
  `
    query getBroadcastKeyMessageGroups($feedId: ID!) {
      broadcastKeyMessageGroups(
        filters: { feedId: $feedId }
        ordering: [{ name: ASC }]
      ) {
        ...BroadcastKeyMessageGroupFragment
      }
    }
  `,
  [BroadcastKeyMessageGroupFragment],
);

// ============================================================================
// Podcast Key Message Groups Query
// ============================================================================

export const GetPodcastKeyMessageGroups = graphql(
  `
    query getPodcastKeyMessageGroups($feedId: ID!) {
      podcastKeyMessageGroups(
        filters: { feedId: $feedId }
        ordering: [{ name: ASC }]
      ) {
        ...PodcastKeyMessageGroupFragment
      }
    }
  `,
  [PodcastKeyMessageGroupFragment],
);
